export default "__VITE_ASSET__DJAV_2j8__"